// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import EditableField from '../../../../shared/components/editable-field';
import {FormattedMessage} from 'react-intl';
import LabeledFormInput from '../../../../shared/components/labeled-form-input';
import {buildDealer} from '../../../../shared/services/build-dealer';
import {getFieldClassName} from '../../../shared/services/claim-shared-helper';
import {translate} from '../../../../shared/services/translation-service';

function handleOptionChange(event) {

    event.persist();
    this.onOptionChange(event.target.value, event);

}

function handleOptionBlur(event) {

    this.onOptionBlur(event.target.value);

}

function getDealer(accountId, dealers) {

    const selectedDealer = dealers.find(dealer => dealer.account === accountId);

    return selectedDealer ? buildDealer(selectedDealer) : accountId;

}

const ResponsibleAccountsDropDown = props => {

    const className = getFieldClassName('responsible-account', props.isValid, props.highlightClass);

    return (
        <LabeledFormInput
            className={className}
            label='DEALER_LOCATION'
        >
            <EditableField
                isEditable={props.isEditable}
                value={getDealer(props.selectedAccount.account, props.dealers)}
            >
                <select
                    onBlur={props::handleOptionBlur}
                    onChange={props::handleOptionChange}
                    value={props.selectedAccount.account}
                >
                    <option value=''/>
                    {
                        props.dealers.map(dealer =>
                            <option
                                key={dealer.account}
                                value={dealer.account}
                            >
                                {buildDealer(dealer)}
                            </option>
                        )
                    }
                </select>
            </EditableField>
            {
                props.isValid ?
                    null :
                    <span className='error-message'>
                        <FormattedMessage id={props.errorMessage}/>
                    </span>
            }
            {
                props.vsrMessage && <span className='vsr-message'>{`${props.vsrMessage} (${translate('SAVE_TO_VALIDATE')})`}</span>
            }
        </LabeledFormInput>
    );

};

ResponsibleAccountsDropDown.displayName = 'ResponsibleAccountsDropDown';
ResponsibleAccountsDropDown.propTypes = {
    dealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    errorMessage: PropTypes.string,
    highlightClass: PropTypes.string,
    isEditable: PropTypes.bool.isRequired,
    isValid: PropTypes.bool.isRequired,
    onOptionBlur: PropTypes.func.isRequired,
    onOptionChange: PropTypes.func.isRequired,
    selectedAccount: PropTypes.instanceOf(Dealer).isRequired,
    vsrMessage: PropTypes.string
};

export default ResponsibleAccountsDropDown;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-fields/responsible-accounts.js